import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, Output, inject, signal } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { SearchFilterPipe } from '@app/shared/pipes/search-filter.pipe';
import { SharedModule } from '@app/shared/shared.module';
import { ConstantVariables } from '@app/shared/util/constant-variables';

@Component({
    selector: 'app-institution-selection-page',
    templateUrl: './institution-selection-page.component.html',
    styleUrl: './institution-selection-page.component.css',
    imports: [CommonModule, SharedModule, SearchFilterPipe]
})
export class InstitutionSelectionPageComponent {
  @Input() countryForm!: FormGroup;
  @Input() countryList: any;
  @Input() showGlobalCountry: boolean = false;
  @Input() globalCountryList: any;
  @Input() institutionList: any;
  @Output() fetchInstitutionList = new EventEmitter<any>();
  constantVariable = inject(ConstantVariables);
  focusFlag = signal(false);
  glbFocusFlag = signal(false);

  getInstitutionList(event: any, fromField?: string) {
    this.fetchInstitutionList.emit({ countryEvent: event, from: fromField });
  }

  isNumber(data: any): boolean {
    if (data)
      return this.constantVariable.onlyNumberPattern.test(data)
    return false;
  }

  setInstitution(autoComplete: any) {
    autoComplete.options.forEach((item: any) => {
      item.deselect()
    });
  }

  displayFn(inst: any): string {
    return inst?.institutionDisplayName || '';
  }
}